module.exports = __webpack_public_path__ + "static/media/eit_food.335be6db.jpg";